export const uiKitsKeys = {
  all: () => ['UI_KITS_DESIGNS'],
  list: ({
    start,
    limit,
    search,
  }: {
    start?: number;
    limit: number;
    search: string;
  }) => ['UI_KITS_DESIGNS', start, limit, search],
  single: (uiKitId: number | null) => ['UI_KIT', uiKitId],
  duplicate: () => ['DUPLICATE_UI_KIT'],
};
